import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * ぷちぽ獲得メッセージ取得
 */
export namespace ApiTaPt060 {
  // GET parameters
  export namespace Get {
    // API Request
    export interface Request {
      query: {
        getPuchipoPoint: number // 獲得ぷちぽ数
      }
    }

    // API Response
    export interface Response {
      puchipoMessage: string // ぷちぽ獲得メッセージ
    }

    // API Path
    export const path: string = '/ta/getPuchipoMessage'
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        puchipoMessage: '',
      }
      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
